import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

// css
import "./RpShiftTimingsConfig.css"
// mui
import Tables from "components/table/table";
import leftarrow from "assets/images/arrow-right.png";

import Context from "context/context";

import Box from '@mui/material/Box';

import 'react-calendar/dist/Calendar.css';
import { toast } from "react-toastify";
import { toastCss } from "config/config";

import rpShiftTimingConfigAPI from "apis/panel/rpShiftTimingConfig/rpShiftTimingConfig";
import { Button, FormControl, Grid, IconButton, MenuItem, Modal, Select, TextField, Typography } from "../../../../../node_modules/@mui/material/index";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import EditIcon from '@mui/icons-material/Edit';
import dayjs from "dayjs";


const style = {
  position: 'absolute',
  top: '60%',
  left: '60%',
  transform: 'translate(-60%, -60%)',
  width: "98%",
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  maxHeight: "90vh",
  overflowY: "scroll",
};

const RpShiftTimingsConfig = () => {
  const { state, dispatch } = useContext(Context);
  const [roleCode] = useState(state.role.roleCode);
  const navigate = useNavigate();
  const [loader2, setLoader2] = useState(false);
  const [load,setLoad] = useState(false)

 const {getAllRpShiftTimingsAPI,createRpShiftTimingsAPI,updateRpShiftTimingsAPI
 } = rpShiftTimingConfigAPI()
 
  const [rpShiftTimingsDetails, setRpShiftTimingsDetails] = useState([])
  const [searchValue, setSearchValue] = useState("");
  const [offset, setOffset] = useState(1);
    const [count, setCount] = useState(1);
    const [allShiftNames,setAllShiftNames] = useState([])

     const [newShiftObj, setNewShiftObj] = useState({
       
        shiftName: "",
        shiftStartTime: null,
        shiftEndTime: null,
        status: "Active",
        
      });
  const [editShiftObj, setEditShiftObj] = useState({});
  const [editData, setEditData] = useState(null);
  const [open, setOpen] = useState(false);
  const [handlePopup, setHandlePopup] = useState({
      type: "",
      open: false,
    });
  
  
const handleNavigation=()=>{
  navigate("/panel/settings")
}

const handleClosePopup = () => {
  setNewShiftObj({
   
    shiftName: "",
   
    shiftStartTime: null,
    shiftEndTime: null,
    status: true,
  
  });
  setHandlePopup({
    type: "",
    open: false,
  });
  setEditShiftObj({});
};


  const handleGetAllRpShiftTimingsApi = async () => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
     
      let res = await getAllRpShiftTimingsAPI();
      setRpShiftTimingsDetails(res?.data?.data|| []);
      let allShifts = res?.data?.data
      if(allShifts){
        let shiftNames =[]
        allShifts.map((e)=>{
          
          shiftNames.push(e.shiftName)
        })
        setAllShiftNames(shiftNames)
      }
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (err) {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };


   const handleOpenEditShiftPopup = (shiftDetails) => {
    
      setNewShiftObj({
        rpShiftTimingsId: shiftDetails.rpShiftTimingsId,
        shiftName: shiftDetails.shiftName,
        shiftStartTime: (shiftDetails.shiftStartTime),
        shiftEndTime: shiftDetails.shiftEndTime,
        status: shiftDetails.status,
       
      });
      setEditShiftObj({ rpShiftTimingsId: shiftDetails.rpShiftTimingsId });
      setHandlePopup({ type: "EDIT", open: true });
    };

  const handleAddNewShift = async () => {
    try {
      const { shiftName, status,shiftStartTime, shiftEndTime } =
        newShiftObj;
       
      if (!shiftName || status == 'null' || !shiftStartTime || !shiftEndTime) {
        return toast.error("Please fill in all required fields.");
      }

      if (handlePopup?.type === "CREATE") {
        if(allShiftNames.some(name => name.toLowerCase() === shiftName.toLowerCase())){
          return toast.error("Shift Name already exists");
        }
      
        const values = {
          
          shiftName,
          status,
          shiftStartTime,
          shiftEndTime,
          
        };
       
        dispatch({ type: "SET_LOADING", payload: true });
        const res = await createRpShiftTimingsAPI(values);
        dispatch({ type: "SET_LOADING", payload: false });
        if (res.status === "Ok") {
          toast.success("Record created successfully.", toastCss);
          setLoad((prev) => !prev);
          handleClosePopup();
        } else {
          toast.error(res.error.message, toastCss);
        }
      } else if (handlePopup?.type === "EDIT") {
        if (editShiftObj && Object.keys(editShiftObj)?.length === 0) {
          return toast.error("Please change at least one field.");
        }

        const {
          shiftName,
          status,
          shiftStartTime,
          shiftEndTime,
          rpShiftTimingsId,
        } = editShiftObj;

        

        let values = { rpShiftTimingsId };

        if (shiftName)
          values = {
            ...values,
            shiftName,
          };
          
        if (status != 'null')
          values = {
            ...values,
            status,
          };

        if (shiftStartTime)
          values = {
            ...values,
            shiftStartTime,
          };

        if (shiftEndTime)
          values = {
            ...values,
            shiftEndTime,
          };

          dispatch({ type: "SET_LOADING", payload: true });
        const res = await updateRpShiftTimingsAPI(values);
        dispatch({ type: "SET_LOADING", payload: false });
        if (res.status === "Ok") {
          toast.success("Record updated successfully.", toastCss);
          setLoad((prev) => !prev);
          handleClosePopup();
        } else {
          toast.error(res.error.message, toastCss);
        }
      }
    } catch (error) {
      setLoader2(false);
    }
  };

  useEffect(() => {
   
handleGetAllRpShiftTimingsApi()
  }, [load])

  return (
    <div
      className="vraPoolMediaQuery"
      style={{
        backgroundColor: "white",
        borderRadius: "10px",
      }}
    >
        <Tables
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div onClick={handleNavigation} style={{ cursor: 'pointer', paddingRight: 8 }}>
              <img src={leftarrow} alt="Back" />
            </div>
            <Box sx={{ pt: 2, pb: 2 }} className="VraPoolTitle">
            Shift Timings
            </Box>
          </div>
        }
          searchBar={false}
          filter={false}
          role={roleCode}
          create={
                  
                    <Button className="AddEmployerButton" onClick={() => {
                      setHandlePopup({ type: "CREATE", open: true });
                    }} >
                        Add Shift Time
                    </Button>
                  }
        
          setSearchValue={setSearchValue}
          heading={[
            "S.No",
            "Shift Name",
            "Shift Start Time",
            "Shift End Time",
            "Status",
            "Actions"     
          ]}
          data={rpShiftTimingsDetails?.map((e, index) => [
          
                index + 1 ,   
                e.shiftName ,
                e.shiftStartTime?dayjs(rpShiftTimingsDetails[index]?.shiftStartTime, 'HH:mm').format('hh:mm A'):null,
                e.shiftEndTime?dayjs(rpShiftTimingsDetails[index]?.shiftEndTime, 'HH:mm').format('hh:mm A'):null,
                <span style={{ color: e.status ? 'green' : 'red' }}>
                {e.status ? "Active" : "InActive"}
                </span>,
                <EditIcon style={{color:"#FE6024",cursor: 'pointer'}} onClick={() => {
                  handleOpenEditShiftPopup(rpShiftTimingsDetails[index]);
                }}/>
              
          ])}
           offset={offset}
           count={count}
          setOffset={setOffset}
          />

         <Modal
                 open={handlePopup?.open}
                 onClose={handleClosePopup}
                 aria-labelledby="modal-title"
                 aria-describedby="modal-description"
               >
         
                 <Box
                   sx={{
                     position: "absolute",
                     top: "50%",
                     left: "50%",
                     transform: "translate(-50%, -50%)",
                     
                     bgcolor: "background.paper",
                     boxShadow: 24,
                     height: "auto",
                     borderRadius: 3,
                     p: 3,
                    
                   }}
                 >
                   <IconButton
                     aria-label="close"
                     onClick={handleClosePopup}
                     sx={{
                       position: "absolute",
                       top: 0,
                       right: 0,
                       color: "inherit",
                       zIndex: 1,
                     }}
                   >

                   </IconButton>
         
                 
         
         
                  <Grid container>
                 <Grid container spacing={3} >
                   
                   <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mb:1 }}>
                     {handlePopup?.type === "EDIT" ? (
                                   <Grid item xs>
                                     <Typography
                                       variant="h6"
                                       style={{ color: "#0070E9", fontWeight: "Bold" }}
                                     >
                                       Edit Shift
                                     </Typography>
                                   </Grid>
                                 ) : (
                                   <Grid item xs>
                                     <Typography
                                       variant="h6"
                                       style={{ color: "#0070E9", fontWeight: "bold" }}
                                     >
                                       Add New Shift
                                     </Typography>
                                   </Grid>
                                 )}
                   </Grid>
                  
                   <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}></Grid>
                   
                   <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                     <Box className="label">Shift Name<span style={{ color: '' }}>*</span></Box>
                     <TextField
                                       className="editvalue"
                                       placeholder="Enter Shift Name"
                                       value={newShiftObj?.shiftName}
                                       onChange={(e) => {
                                         setNewShiftObj({
                                           ...newShiftObj,
                                           shiftName: e.target.value,
                                         });
                                         if (handlePopup?.type === "EDIT")
                                           setEditShiftObj({
                                             ...editShiftObj,
                                             shiftName: e.target.value,
                                           });
                                       }}
                                       sx={{ width: "100%" }}
                                       disabled={handlePopup?.type === "EDIT"} 
                                     />

                      
                    </Grid>
             
                   <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                    
                     <Box className="label">Status</Box>
                    
                     
                     <FormControl sx={{ width: "100%" }}>
                                       <Select
                                      
                                         value={newShiftObj?.status != 'null' ? newShiftObj?.status :true}
                                         
                                         onChange={(e) => {
                                         
                                          
                                           setNewShiftObj({
                                             ...newShiftObj,
                                             status: e.target.value,
                                           });
                                           if (handlePopup?.type === "EDIT")
                                            
                                             setEditShiftObj({
                                               ...editShiftObj,
                                               status: e.target.value,
                                             });
                                         }}
                                         style={{ color: "grey" }}
                                       >
                                         <MenuItem value={true}>Active</MenuItem>
                                         <MenuItem value={false}>InActive</MenuItem>
                                       </Select>
                                     </FormControl>
                  </Grid>
               
                   <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                     <Box className="label">Shift Start Time<span style={{ color: '' }}>*</span></Box>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                                 <DemoContainer components={['TimePicker']} style={{ overflowY: 'scroll' }}>
                                   <TimePicker
                                     label="Start Time"
                                     value={newShiftObj?.shiftStartTime ? dayjs(newShiftObj.shiftStartTime, 'HH:mm') : null}
                                     sx={{ width: '100%' }}
                                     onChange={(newValue) => {
                                       setNewShiftObj({
                                         ...newShiftObj,
                                         shiftStartTime: newValue.format('HH:mm'),
                                       });
                                       if (handlePopup?.type === 'EDIT')
                                         setEditShiftObj({
                                           ...editShiftObj,
                                           shiftStartTime: newValue.format('HH:mm'),
                                         });
                                     }}
                                     viewRenderers={{
                                       hours: renderTimeViewClock,
                                       minutes: renderTimeViewClock,
                                       seconds: renderTimeViewClock,
                                     }}
                                   />
                                 </DemoContainer>
                               </LocalizationProvider>
                  
                   </Grid>
               
                   <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                     <Box className="label">Shift End Time<span style={{ color: '' }}>*</span></Box>
                     <LocalizationProvider dateAdapter={AdapterDayjs}>
                                 <DemoContainer components={['TimePicker']} style={{ overflowY: 'scroll' }}>
                                   <TimePicker
                                     label="End Time"
                                     value={newShiftObj?.shiftEndTime ? dayjs(newShiftObj.shiftEndTime, 'HH:mm') : null}
                                     sx={{ width: '100%' }}
                                     onChange={(newValue) => {
                                       setNewShiftObj({
                                         ...newShiftObj,
                                         shiftEndTime: newValue.format('HH:mm'),
                                       });
                                       if (handlePopup?.type === 'EDIT')
                                         setEditShiftObj({
                                           ...editShiftObj,
                                           shiftEndTime: newValue.format('HH:mm'),
                                         });
                                     }}
                                     viewRenderers={{
                                       hours: renderTimeViewClock,
                                       minutes: renderTimeViewClock,
                                       seconds: renderTimeViewClock,
                                     }}
                                   />
                                 </DemoContainer>
                               </LocalizationProvider>
                  
                   </Grid>
                 </Grid>
               
                 <Grid container sx={{ pl: 4, pr: 5, mt: 4, justifyContent: "center" }}>
                   <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                     <Button className="cancelButton" onClick={handleClosePopup}>Cancel</Button>
                   </Grid>
               
                   <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                     <Button className="saveButton" onClick={handleAddNewShift}>Save</Button>
                   </Grid>
                 </Grid>
                 </Grid>
                 </Box>
               </Modal>
   
    </div>
  )
}


export default RpShiftTimingsConfig